import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { DataState } from '@/types/data.type';

import { CaptionsSliceState } from './captions.type';

const captionsInitialState: CaptionsSliceState = {
    dataMap: {},
    reviewedCaptionsStateMap: {},
};

export const CAPTIONS_REDUCER_NAME = 'captions';

export const captionsSlice = createSlice({
    name: CAPTIONS_REDUCER_NAME,
    initialState: captionsInitialState,
    reducers: {
        appendCaptionsMap: (
            state,
            action: PayloadAction<{
                vttFileUrl: string;
                content: string;
            }>,
        ) => {
            state.dataMap[action.payload.vttFileUrl] = action.payload.content;
        },
        setReviewedCaptionsState: (
            state,
            action: PayloadAction<{
                reelId: string;
                state: DataState;
            }>,
        ) => {
            state.reviewedCaptionsStateMap[action.payload.reelId] =
                action.payload.state;
        },
    },
});

export const { appendCaptionsMap, setReviewedCaptionsState } =
    captionsSlice.actions;

export const captionsReducer = captionsSlice.reducer;
